document.querySelectorAll('.js-video').forEach((video) => {
  const container = document.querySelector('.split-hero-video-container');
  for (let i = 0; i < container.children.length; i++) {
    if (container.children[i].className == 'js-button') {
      const button = container.children[i];
      button.addEventListener('click', () => {
        const playVideo = () => {
          video.play();
        };
        if (video.paused) {
          playVideo();
          button.classList.add('video-playing');
        } else {
          video.pause();
          button.classList.remove('video-playing');
        }
      });
    }
  }
});
